import type { FunctionComponent, InputHTMLAttributes } from 'react';

import { Icon, Icons } from '../../icons';
import type { InputProps } from '../../inputs';

import styles from './MiniChatInput.module.css';

export interface MiniChatInputProps
  extends InputHTMLAttributes<HTMLInputElement>,
    Pick<InputProps, 'errorMessage' | 'supportingText'> {}

export const MiniChatInput: FunctionComponent<MiniChatInputProps> = ({
  disabled,
  errorMessage,
  supportingText,
  value,
  ...rest
}) => {
  return (
    <div className={styles.miniChatInput__container}>
      <div className={styles.miniChatInput}>
        <input value={value} type="text" className={styles.miniChatInput__input} disabled={disabled} {...rest} />
        {disabled ? null : (
          <button className={styles.miniChatInput__action} disabled={!value}>
            <Icon icon={Icons.Send} />
          </button>
        )}
      </div>
      <div className={styles.miniChatInput__supportingText}>
        {errorMessage ? <span className={styles.miniChatInput__errorMessage}>{errorMessage}</span> : null}
        {supportingText && !errorMessage ? supportingText : null}
      </div>
    </div>
  );
};
